module.exports = __webpack_public_path__ + "img/chart_circle_active.d41d8cd9.svg";